module.exports = "<vue-component class=\"tr-page__wrapper\" component=\"ForestMapPage\" v-props=\"currentParams\"></vue-component>\n"